module.exports = __webpack_public_path__ + "static/media/msgimag.11010672.svg";